/* A Triton model is chosen by type and version, sent as <typeName>:v<version> */
export const tritonModelQueryParam = tritonModel =>
  tritonModel
    ? '&tritonModel=' +
      encodeURIComponent(tritonModel.typeName + ':v' + tritonModel.version)
    : '';

export const tritonModelName = tritonModel =>
  tritonModel.alias || tritonModel.typeName + ' v' + tritonModel.version;
